import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconDash: FC<BaseIconProps> = ({ className, ...props }) => {
    return (
        <svg
            className={className}
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3 8H13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    );
};
